const IP_ADDRESS_REGEX = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;

export const parseIpAddresses = (value: string) =>
  value.split(/[\n,]/).reduce<string[]>((ipAddresses, ipAddress) => {
    const trimmed = ipAddress.trim();
    if (trimmed) ipAddresses.push(trimmed);
    return ipAddresses;
  }, []);

export const areIpAddressesValid = (value: string) => {
  const ipAddresses = parseIpAddresses(value);
  return ipAddresses.length > 0 && ipAddresses.every(ipAddress => IP_ADDRESS_REGEX.test(ipAddress));
};

export const getInvalidIpAddressLine = (value: string) =>
  value.split("\n").findIndex(line => parseIpAddresses(line).some(ipAddress => !IP_ADDRESS_REGEX.test(ipAddress))) + 1;
